import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a667c62c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a667c62c')) {
      api.createRecord('a667c62c', component.options)
    } else {
      api.reload('a667c62c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a667c62c&", function () {
      api.rerender('a667c62c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/playground/log/log/index.vue"
export default component.exports